import { useState, useEffect } from "react";
import DigitalProUI from "./DigitalProUI";
import * as toast from "../../Wrapper/toast/toast";
import * as apiHelper from "../../Services/ApiHelper";
import * as stringConstants from "../../Constants/stringConstants";
import * as commonServices from "../../Services/common";
import { isLengthInBetween, isNullOrEmpty } from "../../Utils/stringUtils";

const DigitalPro = () => {
  const [modalShow, setModalShow] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [selectedRoleOptions, setSelectedRoleOptions] = useState([]);
  const [selectedStatusOptions, setSelectedStatusOptions] = useState([]);

  const handleClose = () => {
    setModalShow(false);
    clearData();
  };

  const initialUsersData = {
    id: null,
    name: "",
    email: "",
    password: "",
    mno: "",
    doctor_title: "",
    doctor_details: "",
    gender: "MALE",
    department: "",
    role: "",
    status: "ACTIVE",
    type: "REGULAR",
    login_access: false,
    make_default: false,
    action: "Add",
  };
  const [userData, setUserData] = useState(initialUsersData);

  useEffect(() => {
    getUsersList(lastSelectedPage);
  }, [selectedRoleOptions, selectedStatusOptions]);

  const onPageChange = (page) => {
    getUsersList(page);
  };

  const getUsersList = (page = 1) => {
    const query = `?page=${page}&per_page=10&&query=${searchQuery}`;
    setLastSelectedPage(page);

    const body = {
      status: [...selectedStatusOptions?.map((s) => s.toLowerCase())],
      roles: ["DIGITAL_PRO"],
    };

    setLoading(true);
    apiHelper.getUsers(query, body).then((response) => {
      if (response?.isSuccess) {
        setUsersList(response.data);
      } else {
        toast.warn(response?.message);
      }
      setLoading(false);
    });
  };

  const clearData = () => {
    setUserData(initialUsersData);
  };

  const validateData = () => {
    const { name, status, mno, email, password } = userData;
    let validData = true;

    if (isNullOrEmpty(name)) {
      toast.warn(stringConstants.NAME_REQUIRED());
      validData = false;
    } else if (!isNullOrEmpty(mno) && !isLengthInBetween(mno, 10, 14)) {
      toast.warn(stringConstants.PHONE_NUMBER_INCORRECT);
      validData = false;
    } else if (!isNullOrEmpty(email) && !commonServices.isEmailValid(email)) {
      toast.warn(stringConstants.INCORRECT_EMAIL);
      validData = false;
    } else if (!isNullOrEmpty(password) && !isLengthInBetween(password, 6, 12)) {
      toast.warn(stringConstants.INVALID_PASSWORD);
      validData = false;
    } else if (isNullOrEmpty(status)) {
      toast.warn(stringConstants.STATUS_REQUIRED);
      validData = false;
    }

    return validData;
  };

  const upsertUser = () => {
    if (validateData()) {
      setButtonLoading(true);

      const { id, name, email, password, mno, gender, role, status, action } = userData;

      let data = {
        id,
        name,
        email,
        mno,
        gender,
        role: "DIGITAL_PRO",
        status: status.toLowerCase(),
        login_access: 1,
        default: 1,
      };
      if (!(action === "Edit" && isNullOrEmpty(password))) data.password = password;

      apiHelper
        .upsertUser(data)
        .then((response) => {
          setButtonLoading(false);
          if (response?.isSuccess) {
            if (role === "DOCTOR");
            commonServices.fetchSystemData();
            getUsersList(lastSelectedPage);
            toast.success(response.message);
            setModalShow(false);
            clearData();
          } else {
            toast.warn(response?.message);
          }
        })
        .catch((error) => {
          toast.warn(error.message);
        });
    }
  };
  const isActive = (id) => {
    return !commonServices.removeIfInActive(commonServices.getDepartmentOptions(), id);
  };
  const handleEditClick = (data) => {
    const {
      id,
      name,
      email,
      mno,
      department,
      role,
      status,
      gender,
      login_access,
      type,
      doctor_title,
      doctor_details,
    } = data;

    setUserData({
      ...userData,
      id,
      make_default: data.default,
      name,
      email,
      mno,
      department: isActive(department?.id) ? department?.id : "",
      role,
      status: status.toUpperCase(),
      gender,
      action: "Edit",
      login_access: login_access === 1,
      type: type || "REGULAR",
      doctor_title,
      doctor_details,
    });
    setModalShow(true);
  };

  const handleStatusChange = (data) => {
    setButtonLoading("status-changing" + data.id);
    const status = data.status === "inactive" ? "active" : "inactive";
    const query = `${data.id}?status=${status}`;

    apiHelper.changeUserStatus(query).then((response) => {
      setButtonLoading(false);
      if (response?.isSuccess) {
        getUsersList(lastSelectedPage);
        commonServices.fetchSystemData();
        toast.success(response.message);
      } else {
        toast.warn(response?.message);
      }
    });
  };

  const clearFilter = (e, state) => {
    const dropdownMenu = e.target.closest("#dropdown-basic");
    dropdownMenu.click();
    e.stopPropagation();
    state([]);
  };

  return (
    <DigitalProUI
      modalShow={modalShow}
      setModalShow={setModalShow}
      handleClose={handleClose}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      onPageChange={onPageChange}
      loading={loading}
      buttonLoading={buttonLoading}
      usersList={usersList}
      userData={userData}
      setUserData={setUserData}
      upsertUser={upsertUser}
      handleEditClick={handleEditClick}
      handleStatusChange={handleStatusChange}
      selectedRoleOptions={selectedRoleOptions}
      setSelectedRoleOptions={setSelectedRoleOptions}
      selectedStatusOptions={selectedStatusOptions}
      setSelectedStatusOptions={setSelectedStatusOptions}
      getUsersList={getUsersList}
      clearFilter={clearFilter}
    />
  );
};

export default DigitalPro;
